


/*
function readjson() {
    const data = [
        {
            "path_name": "incoming/loggedin",
            "autocreate": true,
            "execute": "global",
            "create": "loggedin",
            "rename": "loggedin",
            "modify": "loggedin",
            "delete": "loggedin",
            "share": "global",
            "download": "global",
            "process": "global"
        },
        {
            "path_name": "worked_on/loggedin",
            "autocreate": true,
            "execute": "global",
            "create": "loggedin",
            "rename": "loggedin",
            "modify": "loggedin",
            "delete": "loggedin",
            "share": "global",
            "download": "global",
            "process": "global"
        },
        {
            "path_name": "*",
            "autocreate": false,
            "execute": "global",
            "create": "global",
            "rename": "global",
            "modify": "global",
            "delete": "global",
            "share": "global",
            "download": "global",
            "process": "global"
        }
    ];
    return data;
}*/
/*
function readjson2() {
    const data = [
        {"path_name":"files/loggedin/incoming",
        "autocreate":true,
        "execute":"global",             
        "create": "loggedin",
        "rename":"loggedin",
        "modify":"loggedin",
        "delete": "loggedin",
        "share":"global",
        "download":"global",
        "process":"global"
        },
        {"path_name":"files/loggedin/worked_on",
        "autocreate":true,
        "execute":"global",             
        "create": "loggedin",
        "rename":"loggedin",
        "modify":"loggedin",
        "delete": "loggedin",
        "share":"global",
        "download":"global",
        "process":"global"
        },
        {"path_name":"*",
        "autocreate":false,
        "execute":"global",             
        "create": "global",
        "rename":"global",
        "modify":"global",
        "delete": "global",
        "share":"global",
        "download":"global",
        "process":"global"
        }
    ];
    return data;
}


function transform(mdata, mvalue) {
    let mpermissionset = {};
    if (mdata.create == "loggedin") {
        console.log(" set create to " + mvalue);
        mpermissionset.create = mvalue;
    } else {
        mpermissionset.create = mdata.create;
        console.log(" create is " + mdata.create);
    }
    if (mdata.modify == "loggedin") {
        console.log(" set modify to " + mvalue);
        mpermissionset.modify = mvalue;
    } else {
        mpermissionset.modify = mdata.create;
        console.log(" modify is " + mdata.modify);
    }
    if (mdata.rename == "loggedin") {
        console.log(" set rename to " + mvalue);
        mpermissionset.rename = mvalue;
    } else {
        mpermissionset.rename = mdata.rename;
        console.log(" rename is " + mdata.rename);
    }
    if (mdata.delete == "loggedin") {
        console.log(" set delete to " + mvalue);
        mpermissionset.delete = mvalue;
    } else {
        mpermissionset.delete = mdata.delete;
        console.log(" delete is " + mdata.delete);
    }
    if (mdata.share == "loggedin") {
        console.log(" set share to " + mvalue);
        mpermissionset.share = mvalue;
    } else {
        mpermissionset.share = mdata.share;
        console.log(" share is " + mdata.share);
    }
    if (mdata.download == "loggedin") {
        console.log(" set download to " + mvalue);
        mpermissionset.download = mvalue;
    } else {
        mpermissionset.download = mdata.download;
        console.log(" download is " + mdata.download);
    }
    return mpermissionset;
}
*/

/*
function find_perm(data, path, user) {
    //function find_perm(data, path, user) {
    let muser;
    //var mpermission;
    let mpermissionset;
    let configpath_withoutcapture;
    let bContextSensitivePermission = false;
    let path_withoutname = path.replace(user, "");
    var i;
    let bFoundMatch = false;
    for (i = 0; i < data.length; i++) {
        let mdata = data[i];

        //configpath_withoutcapture = mdata.path_name.replace("loggedin", "")
        console.log("configpath_withoutcapture : " + configpath_withoutcapture + " path_withoutname : " + path_withoutname);
        /*if (configpath_withoutcapture != path_withoutname) {
            if (configpath_withoutcapture != "*") {
                console.log("continue skip");
                continue;
            }
        }*//*
// if loggedin is in path... replace with regex group to grab name from input path
let pattern = mdata.path_name.replace("loggedin", "(.*)")
console.log("config path : " + mdata.path_name + " pattern : " + pattern + " test path : " + path);
if (pattern != mdata.path_name) {
// i.e. there was a loggedin within the path
let result = path.match(pattern)
if (result) {
bContextSensitivePermission = true;
console.log("found loggedin");
bFoundMatch = true;
muser = result[1];
if (muser == user) {
console.log("user matches");
mpermissionset = transform(mdata, true);
}
else {
console.log("user doesn't match");
mpermissionset = transform(mdata, false);
}
} else {
console.log("pattern & path_name don't match : " + pattern);
//mpermissionset = this.transform(mdata,false);
}
} else {
// if name from input path doesn't have loggedin as part of path then use settings
if (bContextSensitivePermission == false) {
console.log("setting permission set because loggedin missing ");
mpermissionset = mdata;
}
}
if (bFoundMatch) {
break;
}
}
/* if (bContextSensitivePermission == true) {
let mpermission = mpermissionset.create;
} else {
let mpermission = 'global';
}*//*
//console.log("create permission " + mpermission);
return mpermissionset;
}
*/
function transformvalue(mvalue, permvalue) {
    var bret;
    //console.log("transformvalue function");
    if (mvalue == "deny") {
        bret = false;
    }
    if (mvalue == "allow") {
        bret = true;
    }
    if (mvalue == "global") {
        bret = permvalue;
    }
    return bret;
}


function transformvalues(mdata, perm) {
    //console.log("transformvalues");
    //console.log("input create permission : " + mdata.create + " perm was : " + perm.create);
    let newdata = {};
    newdata.create = transformvalue(mdata.create, perm.create);
    //console.log("set create permission : " + newdata.create + " perm was : " + perm.create);
    newdata.delete = transformvalue(mdata.delete, perm.delete);
    newdata.download = transformvalue(mdata.download, perm.download);
    newdata.modify = transformvalue(mdata.modify, perm.modify);
    newdata.rename = transformvalue(mdata.rename, perm.rename);
    newdata.share = transformvalue(mdata.share, perm.share);

    return newdata;
}

function transform(mdata, perm, mvalue) {
    let mpermissionset = {};
    //console.log("transform funcion");
    if (mdata.create == "loggedin") {
        mpermissionset.create = mvalue;
    } else {
        mpermissionset.create = transformvalue(mdata.create, perm.create);
    }
    if (mdata.delete == "loggedin") {
        mpermissionset.delete = mvalue;
    } else {
        mpermissionset.delete = transformvalue(mdata.delete, perm.delete);
    }
    if (mdata.download == "loggedin") {
        mpermissionset.download = mvalue;
    } else {
        mpermissionset.download = transformvalue(mdata.download, perm.download);
    }
    if (mdata.modify == "loggedin") {
        mpermissionset.modify = mvalue;
    } else {
        mpermissionset.modify = transformvalue(mdata.modify, perm.modify);
    }
    if (mdata.rename == "loggedin") {
        mpermissionset.rename = mvalue;
    } else {
        mpermissionset.rename = transformvalue(mdata.rename, perm.rename);
    }
    if (mdata.share == "loggedin") {
        mpermissionset.share = mvalue;
    } else {
        mpermissionset.share = transformvalue(mdata.share, perm.share);
    }
    return mpermissionset;
}
function find_perm(data, path, user, perm) {
    let muser;
    let i, j;
    //let mpermission;
    let mpermissionset;
    //let configpath_withoutcapture;
    let pattern;
    let result;
    let bContextSensitivePermission = false;
    //let path_withoutname = path.replace(user, "");
    let bFoundMatch = false;
    for (i = 0; i < data.length; i++) {
        let mdata = data[i];
        console.log("create permission " + mdata.create);
        /*configpath_withoutcapture = mdata.path_name.replace("loggedin", "")
        console.log("configpath_withoutcapture : " + configpath_withoutcapture + " path_withoutname : " + path_withoutname);
        if (configpath_withoutcapture != path_withoutname) {
            if (configpath_withoutcapture != "*") {
                console.log("continue skip");
                continue;
            }
        }*/
        // if loggedin is in path... replace with regex group to grab name from input path
        for (j = 0; j < mdata.paths.length; j++) {
            console.log("config path : " + mdata.paths[j] + " test path : " + path);
            pattern = mdata.paths[j].replace("loggedin", "(.+)")
            if (pattern != mdata.paths[j]) {
                // i.e. there was a loggedin within the path
                result = path.match(pattern)
                if (result) {
                    bContextSensitivePermission = true;
                    console.log("found loggedin");
                    bFoundMatch = true;
                    muser = result[1];
                    if (muser == user) {
                        console.log("user matches");
                        mpermissionset = transform(mdata, perm, true);
                    }
                    else {
                        console.log("user doesn't match");
                        mpermissionset = transform(mdata, perm, false);
                    }
                } else {
                    console.log("pattern & path_name don't match : " + pattern);
                    //mpermissionset = this.transform(mdata,false);
                }
            } else {
                // if name from input path doesn't have loggedin as part of path then use settings
                if (bContextSensitivePermission == false) {
                    // test for exact match before allowing woild card match
                    if (mdata.paths[j] == path) {
                        console.log("config path & path_name match exactly ");
                        mpermissionset = transformvalues(mdata, perm);
                        bFoundMatch = true;
                    }
                    if (bFoundMatch == false) {
                        // transform for potential values..
                        mpermissionset = transformvalues(mdata, perm);
                    }
                    //mpermissionset = mdata;
                }
            }
            if (bFoundMatch) {
                break;
            }
        }
        if (bFoundMatch) {
            break;
        }

    }
    /*if (bContextSensitivePermission == true) {
        mpermission = mpermissionset.create;
    } else {
        mpermission = 'global';
    }*/
    //console.log("create permission " + mpermission);
    return mpermissionset;
}

export function workout_permissions(path, perm, selectedCount, enableExec, username, contexts, showmakenotes) {
    //function workout_permissions(path, perm, selectedCount, enableExec, username, contexts) {
    //console.log("Work out permissions");
    console.log(contexts);
    console.log("path " + path + " context sensitive " + perm.contextsensitive + " selectedCount " + selectedCount + " enableExec " + enableExec + " username " + username);
    let newperms = find_perm(contexts, path, username, perm);
    /*console.log(" N create " + newperms.create + " N download " + newperms.download);
    if (newperms.create == "global") {
        newperms.create = perm.create;
    }
    if (newperms.download == "global") {
        newperms.download = perm.download;
    }*/
    var buttonpermissions = {
        upload: newperms.create,
        download: newperms.download,
        shell: newperms.execute && enableExec,
        delete: selectedCount > 0 && newperms.delete,
        rename: selectedCount === 1 && newperms.rename,
        share: selectedCount === 1 && newperms.share,
        move: selectedCount > 0 && newperms.rename,
        copy: selectedCount > 0 && newperms.rename,
        makenotes: selectedCount > 0 && showmakenotes,
    };
    return buttonpermissions;
}
    /*
export function store_data() {
const data = readjson();
/*for(i=0;i<data.length;i++)
{
let mdata = data[i]; *//*
store.commit("setContext", data);
//}
}*/
/*
    //export function input_contexts() {
    function input_contexts() {
        const data = this.readjson();
        //const data = this.state.contexts;
        var path = "incoming/sue_totham";
        var user = "sue_totham";
        console.log("========= user : " + user + " ====== path : " + path);
        permissionset = this.find_perm(data, path, user);
        console.log("Create permission : " + permissionset.create);
    }
    /*
    function input_wrong_user(){
        const data = this.readjson();
        var path = "incoming/sue_totham";
        var user = "graham_bowley";
        console.log("========= user : " + user + " ====== path : " + path);
        permissionset = this.find_perm(data,path,user);
        console.log("Create permission : " + permissionset.create);
    }

    function input_wildpath(){
        const data = this.readjson();
        var path = "medication";
        var user = "graham_bowley";
        console.log("========= user : " + user + " ====== path : " + path);
        permissionset = this.find_perm(data,path,user);
        console.log("Create permission : " + permissionset.create);
    }

    function input_rightuser_inmiddle(){
        const data = this.readjson2();
        var path = "files/sue_totham/incoming";
        var user = "sue_totham";
        console.log("========= user : " + user + " ====== path : " + path);
        permissionset = this.find_perm(data,path,user);
        console.log("Create permission : " + permissionset.create);
    }

    function input_rightuser_inmiddle2(){
        const data = this.readjson2();
        var path = "files/sue_totham/worked_on";
        var user = "sue_totham";
        console.log("========= user : " + user + " ====== path : " + path);
        permissionset = this.find_perm(data,path,user);
        console.log("Create permission : " + permissionset.create);
    }
    function input_wronguser_inmiddle(){
        const data = this.readjson2();
        var path = "files/sue_totham/incoming";
        var user = "graham_bowley";
        console.log("========= user : " + user + " ====== path : " + path);
        permissionset = this.find_perm(data,path,user);
        console.log("Create permission : " + permissionset.create);
    }

    function input_wronguser_inmiddle2(){
        const data = this.readjson2();
        var path = "files/sue_totham/worked_on";
        var user = "graham_bowley";
        console.log("========= user : " + user + " ====== path : " + path);
        permissionset = this.find_perm(data,path,user);
        console.log("Create permission : " + permissionset.create);
    }
    */


//export default Contexts;
/*module.exports = {
    workout_permissions,
    input_contexts
    //Contexts;
}*/